<template>
<div class="main">
	<Steps :index="1" product-name="平安企业团体雇主责任保险" />
    <ApplicantInfo :info="info" title="投保企业信息"/>
    <RecognizeInfo :info="info" class="mt20"/>
    <InvoiceInfo :info="info" />
    <InsuranceSlip :info="info" ref="insurance" :multiple="true" />
	<div class="mt15 agree">
    	<Checkbox v-model="agree">我已经阅读并同意</Checkbox>
    	<a href="/static/pdf/haierProduct/平安雇主责任保险（A款）条款.pdf" target="_blank">《平安雇主责任保险（A款）条款》</a>
    </div>
    <div class="mt20 center">
        <p>实际支付：<span class="price">{{info.amount}}元</span></p>
        <p class="mt10">
            <Button type="primary" @click="toPay" :disabled="!agree" :loading="loading">立即支付</Button>
        </p>
    </div>
</div>
</template>
<script>
import RecognizeInfo from './RecognizeInfo'
import ApplicantInfo from './common/ApplicantInfo'
import InvoiceInfo from './common/InvoiceInfo'
import Steps from '../common/Steps'
import InsuranceSlip from '../common/InsuranceSlip'
import track from "@/mixin/track";
export default {
	mixins:[track],
	components:{ RecognizeInfo,ApplicantInfo,InvoiceInfo,Steps,InsuranceSlip },
	data () {
		return {
			info:{
				id:this.$route.params.id,
			},
			loading:false,
			agree:false,
			id:this.$route.params.id
		}
	},
	created(){
		if(this.id){
			this.getInfo()
		}
	},
	mounted () {
		// 回溯 开始录制
		// this.$nextTick(this.startRecord);
	},
	methods:{
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/employerLiability/getDetailInfo.json',{
				policyId:this.id
			}).then(res=>{
				this.info=res;
				if(res.list&&res.list.length>0){
					this.info.subjoinAllDay=res.list[0].subjoinAllDay
					this.info.subjoinOwnMedicine=res.list[0].subjoinOwnMedicine
					this.info.subjoinProportionAdj=res.list[0].subjoinProportionAdj
				}
			});
		},
		async toPay () {
			/*获取投保单*/
			let insuranceForm = await this.$refs.insurance.val();
			if(!insuranceForm){
			    this.toast('请上传投保单','error');
				return
			}
			let insurancePolicyUrl=insuranceForm.insurancePolicyUrl.map(item=>{
				return item.insurancePolicyUrl 
			})
			this.loading=true;
			this.$axios.post('/employerLiability/createBizOrder.all',{
				policyId:this.id,
				insurancePolicyUrl:insurancePolicyUrl.toString(),
				productCode:this.info.productCode
			}).then(async res=>{
				this.loading = false;
				if(res.code==10000000){
					// 回溯 停止录制
					// await this.stopRecord({
					// 	session_key:sessionStorage.track_session_key,
					// 	policy_id:this.id
					// });
					window.location.href=`/common.html#/new-pay?orderNo=${res.data}&productCode=${this.info.productCode}`
				}else{
					this.alert(res.msg);
				}
			});
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		background: #fff;
		margin-top: 15px;
		padding :30px 40px;
	}
	.mt20{
	    font-size: 25px;
	    line-height: 1.8;
	}
	span.price{
	    color:#FF0000;
	    font-weight: bold;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployer/Confirm.vue